<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-exclamation-triangle', fontSet: 'fad'}"
	[headerText]="T.SKIP_SESSION_DIALOG_SKIP_RUN | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		{{ T.SKIP_SESSION_DIALOG_WARNING | translate }}
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'ok', followUpAction: 'cancel'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			color="warn"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			(onClick)="
				close({
					action: 'ok',
					followUpAction: 'abort-previous-session-run',
				})
			"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-forward'}"
			color="accent"
			[label]="T.SKIP_SESSION_DIALOG_SKIP_PREVIOUS"
		/>
	</ng-container>
</sim-basic-material-dialog>
